const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
export const API_HOST = isLocal ? 'http://localhost:5000' : '';
export const API_BASE = isLocal ? 'http://localhost:5000/api' : '/api';

export const CONTACT_PHONE = '+370 605 17874';
export const CONTACT_PHONE_HREF = 'tel:+37060517874';
export const CONTACT_EMAIL = 'info@fitit.lt';
export const CONTACT_EMAIL_HREF = 'mailto:info@fitit.lt';
export const PAYSERA_URL = 'https://www.fitit.lt/libwebtopay2/redirect.php';

export const IS_DEV = isLocal;
